const Footer = () => {
  return (
    <footer className="bg-[#1A4D2E] border-t border-[#153d24] py-4 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <p className="text-xs text-emerald-200/60 tracking-wide">
          &copy; 2026 Samy Sellali &ndash; Tous droits r&eacute;serv&eacute;s.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
